"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuList = exports.StyledMenuSection = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledMenuSection = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .menu-section-title {
    line-height: 2.5rem;
    color: ${ui_components_1.baseColors.background600};
    padding: ${({ theme }) => theme.spacing(0, 1)};
    text-transform: uppercase;
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
`;
exports.StyledMenuList = (0, styled_components_1.default)(material_1.List) `
  && {
    width: 100%;
    gap: ${({ theme }) => theme.spacing(0.5)};
    flex-direction: column;
    padding: 0;
  }

  .MuiListItemAvatar-root {
    height: 1.5rem;
    min-width: 2rem;
  }

  .MuiListItemText-primary,
  .MuiListItemText-secondary {
    font-size: 0.75rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .MuiListItemText-secondary {
    color: ${({ theme }) => theme.palette.accent.main};
  }

  .MuiListItem-root {
    background-color: ${ui_components_1.baseColors.background000};
    padding-right: 6.5rem;
    border-radius: 4px;

    &.list-item--selectable {
      cursor: pointer;

      & > div > span {
        cursor: pointer;
      }

      &:hover {
        background-color: ${ui_components_1.baseColors.primaryGreen001};
      }
    }
  }
`;
